class PriceReview extends HTMLElement {
  constructor() {
    super();
    this.setupMutationObserver();
    setTimeout(() => this.movePrice(), 2000);
  }

  movePrice() {
    const hasYotpoWidget = this.querySelector('[data-widget-name="preview_badge"]');
    const priceElement = this.querySelector('[data-review-price]');
    if (!hasYotpoWidget || !priceElement) return false;

    // Move price element and reveal it
    hasYotpoWidget.insertBefore(priceElement, hasYotpoWidget.firstChild);
    hasYotpoWidget.style.removeProperty('display');
    priceElement.classList.remove('hidden');
    this.classList.add('active');

    return true;
  }

  setupMutationObserver() {
    const observer = new MutationObserver(() => {
      if (this.movePrice()) {
        observer.disconnect(); // optional: stop observing once done
      }
    });

    observer.observe(this, {
      childList: true,
      subtree: true
    });
  }
}

if (!customElements.get('price-review')) {
  customElements.define('price-review', PriceReview);
}
